<template>
  <div class="logo-component">
    <template v-if="isFetching">
      <img src="/images/loading.gif" />
    </template>
    <template v-else>
      <BaseButton
        v-if="!currentLogo"
        class="logo-component__button"
        @click="active = true"
      >
        ADD YOUR
        <br />
        COMPANY LOGO
      </BaseButton>
      <LogoImageContainer
        v-else
        :report-type-id="reportTypeId"
        @edit="active = true"
        @delete="handleDelete()"
      />
      <LogoModal
        v-if="active"
        :report-type-id="reportTypeId"
        :current-logo="currentLogo"
        :report-type-logo="reportTypeLogo"
        @close="active = false"
        @new-image-selected="handleNewImageSelected"
      />
    </template>
    <BaseDialog
      ref="confirmation-dialog"
      :padding="false"
      class="image-dialog"
      @close-dialog="handleCloseDialogEvent()"
    />
  </div>
</template>

<script>
  import axios from 'axios';
  import LogoModal from './LogoModal.vue';
  import LogoImageContainer from './LogoImageContainer.vue';
  import BaseButton from '~/components/base/BaseButton.vue';
  import BaseDialog from '~/components/base/BaseDialog.vue';
  import { useConsultingStore } from '~/stores/consulting';

  export default {
    name: 'LogoComponent',
    components: {
      LogoModal,
      LogoImageContainer,
      BaseButton,
      BaseDialog,
    },
    props: {
      reportTypeId: {
        type: [Number, String],
        required: true,
      },
    },
    data: () => ({
      active: false,
    }),
    setup() {
      const consultingStore = useConsultingStore();
      return { consultingStore };
    },
    computed: {
      isFetching() {
        return this.consultingStore.getIsFetching;
      },
      currentLogo() {
        return this.consultingStore.getCurrentLogo;
      },
      reportTypeLogo() {
        return this.consultingStore.getReportTypeLogo;
      },
    },
    async created() {
      await this.consultingStore.setCurrentLogo(this.reportTypeId);
    },
    methods: {
      async handleDelete() {
        const response = await this.$refs['confirmation-dialog'].prompt({
          title:
            '<span style="font-size: 30px; font-weight: 700">Are you sure?</span>',
          message: `<div style="font-size: 20px; font-weight: 700; color: var(--itr-charcoal); text-align: center; width: 80%; margin: 0 auto;">Please confirm you would like to remove the logo associated with your report.</div>`,
          confirmText: 'Remove Logo',
          cancelText: 'Cancel',
          level: 'success',
        });

        if (response) {
          try {
            await axios.delete(
              `/company-logo/report-type/${this.reportTypeId}`
            );
            this.clearLogo();
          } catch (err) {
            // TODO: HANDLE ERROR - This is just silencing the error
          }
        }
      },
      handleNewImageSelected(data) {
        this.active = data.close;
      },
      clearLogo() {
        this.consultingStore.resetReportTypeLogo();
      },
      async handleCloseDialogEvent() {
        await this.$refs['confirmation-dialog'].__cancel();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .logo-component {
    &__button {
      line-height: 1.6;
    }
  }
</style>
